import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { memo } from 'react';

import { Price } from '@flipster/ui';
import { TableCell } from '@flipster/ui/Table';

import { openPositionRowDataBunja } from '../row-bunja';

interface Props {
  field: 'entryPrice' | 'markPrice' | 'liquidationPrice';
  zeroString?: string;
}

const PriceCell = memo(({ field, zeroString }: Props) => {
  const { entryPriceAtom, markPriceAtom, liqPriceAtom, instrumentAtom } = useBunja(openPositionRowDataBunja);
  const priceAtom = field === 'entryPrice' ? entryPriceAtom : field === 'markPrice' ? markPriceAtom : liqPriceAtom;
  const price = useAtomValue(priceAtom);
  const instrument = useAtomValue(instrumentAtom);

  if (!instrument) return null;

  return (
    <TableCell>
      <Price price={price} fontType='num4' zeroString={zeroString} precision={instrument.pricePrecision} toFixed />
    </TableCell>
  );
});

export default PriceCell;
